import { GiftIcon, PlusIcon } from "@xola/icons";
import { Button } from "@xola/ui-kit";
import React from "react";
import { Permission, PopupCheckoutType } from "types";
import { IsGranted } from "../../Common/IsGranted";
import { RadioInput } from "../../Common/RadioInput";

interface ButtonStyleProps {
    popupType: PopupCheckoutType;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

// This section allows users to choose between default and custom styles for popup checkout buttons.
export const ButtonStyle = ({ popupType, onChange }: ButtonStyleProps) => {
    return (
        <div className="space-y-2">
            <div className="text-md font-bold">Button Style</div>
            <div className="flex w-full flex-row justify-between rounded border border-gray-light p-4">
                <div className="space-y-1">
                    <RadioInput
                        name="popupType"
                        checked={popupType === PopupCheckoutType.DEFAULT}
                        value={PopupCheckoutType.DEFAULT}
                        onChange={onChange}
                    >
                        Default
                    </RadioInput>
                    <RadioInput
                        name="popupType"
                        checked={popupType === PopupCheckoutType.CUSTOM}
                        value={PopupCheckoutType.CUSTOM}
                        onChange={onChange}
                    >
                        Custom
                    </RadioInput>
                </div>
                {popupType === PopupCheckoutType.DEFAULT ? (
                    <div className="flex items-center space-x-8">
                        <p className="text-lg font-bold">Preview:</p>
                        <div className="space-x-4">
                            <Button size="large" color="primary" icon={<PlusIcon />}>
                                Book Now
                            </Button>
                            <IsGranted permissions={Permission.GIFT_OFFERS_VIEW}>
                                <Button size="large" color="primary" icon={<GiftIcon />}>
                                    Buy Gift
                                </Button>
                            </IsGranted>
                        </div>
                    </div>
                ) : (
                    <CustomStyleMessage />
                )}
            </div>
        </div>
    );
};

const CustomStyleMessage = () => {
    return (
        <div className="px-4">
            You can style the Xola button to match your site&apos;s theme by defining a CSS class called{" "}
            <span className="bg-gray-lighter py-0.5 px-1 font-mono text-sm text-danger">
                <var data-var="className">xola-custom</var>
            </span>
            . For sample styles, visit{" "}
            <a target="_blank" href="http://bestcssbuttongenerator.com" rel="noreferrer">
                <var data-var="url">BestCSSButtonGenerator.com</var>
            </a>
        </div>
    );
};
